// multicolumn-image-links.js
// Makes multicolumn images clickable using the existing column link URL (button/link text).
(function () {
  function makeMulticolumnImagesClickable(root = document) {
    const sections = root.querySelectorAll('.multicolumn');

    sections.forEach((section) => {
      // Dawn typically uses .multicolumn-card; other themes may use similar card wrappers.
      const cards = section.querySelectorAll('.multicolumn-card');

      cards.forEach((card) => {
        // 1) Find an existing link URL in this column (button link / text link).
        // Try common Dawn selectors first.
        const linkEl =
          card.querySelector('.multicolumn-card__info a[href]') ||
          card.querySelector('a.button[href]') ||
          card.querySelector('a[href]');

        if (!linkEl) return;

        const href = linkEl.getAttribute('href');
        if (!href || href === '#') return;

        // 2) Find the image wrapper (Dawn) or the first image in the card.
        const imageWrapper =
          card.querySelector('.multicolumn-card__image-wrapper') ||
          card.querySelector('.multicolumn-card__image') ||
          card.querySelector('.multicolumn-card__media') ||
          card.querySelector('img')?.closest('div');

        if (!imageWrapper) return;

        // If the image is already inside an anchor, do nothing.
        const existingAnchor = imageWrapper.closest('a[href]');
        if (existingAnchor) return;

        // Avoid wrapping if there is already an anchor inside the image wrapper.
        if (imageWrapper.querySelector('a[href]')) return;

        // 3) Wrap the image wrapper in an anchor pointing to the existing href.
        const a = document.createElement('a');
        a.href = href;
        a.className = 'pf-clickable-multicolumn-image';
        a.setAttribute('aria-label', linkEl.textContent?.trim() || 'View');

        // Preserve target/rel if your existing link uses them
        if (linkEl.target) a.target = linkEl.target;
        const rel = linkEl.getAttribute('rel');
        if (rel) a.setAttribute('rel', rel);

        // Insert anchor before wrapper, then move wrapper inside anchor
        imageWrapper.parentNode.insertBefore(a, imageWrapper);
        a.appendChild(imageWrapper);
      });
    });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', () => {
    makeMulticolumnImagesClickable(document);
  });

  // Run again if Shopify dynamically re-renders sections in Theme Editor
  document.addEventListener('shopify:section:load', (event) => {
    makeMulticolumnImagesClickable(event.target);
  });
})();
